const distributorOverview = {
  'View unit activity in your tissue bank.':
    'Consulte la actividad de unidades en su banco de tejidos.',
  'Upcoming deliveries': 'Próximas entregas',
  'View shipments': 'Ver envíos',
  'Requested dates · Next 3 open orders': 'Fechas solicitadas · Próximas 3 órdenes abiertas',
  'Deliveries are unavailable. Refresh to try again.':
    'Entregas no disponibles. Actualice para volver a intentarlo.',
  'Loading deliveries…': 'Cargando entregas…',
  'No upcoming delivery dates.': 'No hay fechas de entrega próximas.',
  'Recent bank activity': 'Actividad bancaria reciente',
  'View bank activity': 'Ver actividad bancaria',
  'Bank activity is unavailable. Refresh to try again.':
    'Actividad bancaria no disponible. Actualice para volver a intentarlo.',
  'Loading bank activity…': 'Cargando actividad bancaria…',
  'Bank summary': 'Resumen del banco',
  'Balance unavailable. Refresh to try again.':
    'Saldo no disponible. Actualice para volver a intentarlo.',
  'Loading balance…': 'Cargando saldo…',
  'Spending is paused. Review your tissue bank.':
    'Los gastos están pausados. Revise su banco de tejidos.',
  'View balances by product family.': 'Consulte los saldos por familia de productos.',
  'Open tissue bank': 'Abrir banco de tejidos',
  'Recent orders': 'Órdenes recientes',
  'View all orders': 'Ver todas las órdenes',
  'Recent orders are unavailable. Refresh to try again.':
    'Las órdenes recientes no están disponibles. Actualice para volver a intentarlo.',
  'Loading orders…': 'Cargando órdenes…',
  'No orders yet.': 'Aún no hay órdenes.',
  'Go to Orders': 'Ir a Órdenes',
  'Recent orders table': 'Tabla de órdenes recientes',
  Order: 'Orden',
  Customer: 'Cliente',
  'View order {id}': 'Ver orden {id}',
  Updates: 'Actualizaciones',
  'Automatic updates are paused.': 'Las actualizaciones automáticas están pausadas.',
  'No notices to show.': 'No hay avisos para mostrar.',
};
export default distributorOverview;
